import { ensureCustomFilterStyle } from './filterStyles';
import { parseAreaCandidatesM2 } from './filterUtils';

/**
 * 면적 범위 필터 (㎡ / 평)
 * 사용 예: { filter: AreaRangeFilter }
 */
class AreaRangeFilter {
  init(params) {
    ensureCustomFilterStyle();
    this.params = params;
    this.model = null;
    this.unit = 'pyeong'; // 기본값을 평으로 변경
    this.onClose = params.onClose || null;
    this.gui = document.createElement('div');
    this.gui.className = 'aptrank-custom-filter';
    this.render();
  }

  render() {
    const from = this.model?.from ?? '';
    const to = this.model?.to ?? '';
    const unit = this.unit === 'pyeong' ? 'pyeong' : 'm2';

    const minVal = unit === 'pyeong' ? 0 : 0;
    const maxVal = unit === 'pyeong' ? 100 : 330;
    const step = unit === 'pyeong' ? 1 : 10;
    const fromNum = from || minVal;
    const toNum = to || maxVal;

    this.gui.innerHTML = `
      <button type="button" class="complex-top-filter-panel-close" style="position: absolute; top: 8px; right: 8px; border: none; background: transparent; color: #64748b; width: 28px; height: 28px; border-radius: 8px; font-size: 24px; line-height: 1; cursor: pointer; z-index: 10;">×</button>
      <div style="display: flex; gap: 8px; align-items: center; margin-bottom: 12px;">
        <span style="font-size: 14px; font-weight: 600; color: #374151;">단위:</span>
        <button class="aptrank-custom-filter-unit-toggle-btn unit-m2" type="button" style="padding: 6px 12px; border: 1px solid ${unit === 'm2' ? '#16a34a' : '#d1d5db'}; background: ${unit === 'm2' ? '#f0fdf4' : '#fff'}; border-radius: 6px; font-size: 13px; cursor: pointer; color: ${unit === 'm2' ? '#16a34a' : '#6b7280'}; font-weight: 600;">m²</button>
        <button class="aptrank-custom-filter-unit-toggle-btn unit-pyeong" type="button" style="padding: 6px 12px; border: 1px solid ${unit === 'pyeong' ? '#16a34a' : '#d1d5db'}; background: ${unit === 'pyeong' ? '#f0fdf4' : '#fff'}; border-radius: 6px; font-size: 13px; cursor: pointer; color: ${unit === 'pyeong' ? '#16a34a' : '#6b7280'}; font-weight: 600;">평</button>
      </div>
      <div class="aptrank-custom-filter-title-edit">
        <input class="title-from" inputmode="decimal" placeholder="최소" value="${from}" />
        <span>~</span>
        <input class="title-to" inputmode="decimal" placeholder="최대" value="${to}" />
        <span style="margin-left: 4px; color: #6b7280; font-size: 13px;">${unit === 'm2' ? 'm²' : '평'}</span>
      </div>
      <div class="aptrank-custom-filter-slider-wrap">
        <div class="aptrank-custom-filter-slider-track" style="left: ${(fromNum / maxVal) * 100}%; right: ${100 - (toNum / maxVal) * 100}%;"></div>
        <input class="aptrank-custom-filter-slider from-slider" type="range" min="${minVal}" max="${maxVal}" step="${step}" value="${fromNum}" />
        <input class="aptrank-custom-filter-slider to-slider" type="range" min="${minVal}" max="${maxVal}" step="${step}" value="${toNum}" />
      </div>
      <div class="aptrank-custom-filter-grid">
        ${unit === 'pyeong' ? `
          <button class="aptrank-custom-filter-chip" data-range="0-10">~10평</button>
          <button class="aptrank-custom-filter-chip" data-range="10-20">10평대</button>
          <button class="aptrank-custom-filter-chip" data-range="20-30">20평대</button>
          <button class="aptrank-custom-filter-chip" data-range="30-40">30평대</button>
          <button class="aptrank-custom-filter-chip" data-range="40-50">40평대</button>
          <button class="aptrank-custom-filter-chip" data-range="50-60">50평대</button>
          <button class="aptrank-custom-filter-chip" data-range="60-70">60평대</button>
          <button class="aptrank-custom-filter-chip" data-range="70-999">70평~</button>
        ` : `
          <button class="aptrank-custom-filter-chip" data-range="0-33">~33㎡</button>
          <button class="aptrank-custom-filter-chip" data-range="33-66">33~66㎡</button>
          <button class="aptrank-custom-filter-chip" data-range="66-99">66~99㎡</button>
          <button class="aptrank-custom-filter-chip" data-range="99-132">99~132㎡</button>
          <button class="aptrank-custom-filter-chip" data-range="132-165">132~165㎡</button>
          <button class="aptrank-custom-filter-chip" data-range="165-198">165~198㎡</button>
          <button class="aptrank-custom-filter-chip" data-range="198-231">198~231㎡</button>
          <button class="aptrank-custom-filter-chip" data-range="231-999">231㎡~</button>
        `}
      </div>
      <div class="aptrank-custom-filter-actions">
        <button class="aptrank-custom-filter-reset" type="button">초기화</button>
        <button class="aptrank-custom-filter-apply" type="button">적용</button>
      </div>
    `;

    const setUnit = (nextUnit) => {
      const prevUnit = this.unit;
      this.unit = nextUnit === 'pyeong' ? 'pyeong' : 'm2';

      // 값 변환
      if (this.model && prevUnit !== this.unit) {
        if (this.unit === 'pyeong') {
          // m2 -> 평
          this.model.from = Math.round((this.model.from / 3.305785) * 10) / 10;
          this.model.to = Math.round((this.model.to / 3.305785) * 10) / 10;
        } else {
          // 평 -> m2
          this.model.from = Math.round((this.model.from * 3.305785) * 10) / 10;
          this.model.to = Math.round((this.model.to * 3.305785) * 10) / 10;
        }
        this.model.unit = this.unit;
      }

      this.render();
    };

    const applyFilter = () => {
      const fromVal = Number(this.gui.querySelector('input.title-from').value);
      const toVal = Number(this.gui.querySelector('input.title-to').value);
      if (!Number.isFinite(fromVal) && !Number.isFinite(toVal)) {
        this.model = null;
      } else {
        this.model = {
          unit: this.unit,
          from: Number.isFinite(fromVal) ? fromVal : 0,
          to: Number.isFinite(toVal) ? toVal : Number.POSITIVE_INFINITY,
        };
      }
      this.params.filterChangedCallback();
    };

    const updateSlidersFromInputs = () => {
      const fromInput = this.gui.querySelector('input.title-from');
      const toInput = this.gui.querySelector('input.title-to');
      const fromSlider = this.gui.querySelector('.from-slider');
      const toSlider = this.gui.querySelector('.to-slider');

      const fromVal = fromInput.value ? Number(fromInput.value) : 0;
      const toVal = toInput.value ? Number(toInput.value) : (this.unit === 'pyeong' ? 100 : 330);

      const maxVal = this.unit === 'pyeong' ? 100 : 330;
      fromSlider.value = Math.min(fromVal, maxVal);
      toSlider.value = Math.min(toVal, maxVal);

      const track = this.gui.querySelector('.aptrank-custom-filter-slider-track');
      track.style.left = `${(fromSlider.value / maxVal) * 100}%`;
      track.style.right = `${100 - (toSlider.value / maxVal) * 100}%`;
    };

    const updateInputsFromSliders = () => {
      const fromSlider = this.gui.querySelector('.from-slider');
      const toSlider = this.gui.querySelector('.to-slider');
      const fromInput = this.gui.querySelector('input.title-from');
      const toInput = this.gui.querySelector('input.title-to');

      let fromVal = Number(fromSlider.value);
      let toVal = Number(toSlider.value);

      if (fromVal > toVal) {
        [fromVal, toVal] = [toVal, fromVal];
      }

      fromInput.value = fromVal;
      toInput.value = toVal;

      const maxVal = this.unit === 'pyeong' ? 100 : 330;
      const track = this.gui.querySelector('.aptrank-custom-filter-slider-track');
      track.style.left = `${(fromVal / maxVal) * 100}%`;
      track.style.right = `${100 - (toVal / maxVal) * 100}%`;

      applyFilter();
    };

    // 슬라이더 변경 시 입력 필드 업데이트만 (적용은 버튼으로)
    this.gui.querySelector('.from-slider').addEventListener('input', () => {
      const fromSlider = this.gui.querySelector('.from-slider');
      const toSlider = this.gui.querySelector('.to-slider');
      const fromInput = this.gui.querySelector('input.title-from');
      const toInput = this.gui.querySelector('input.title-to');

      let fromVal = Number(fromSlider.value);
      let toVal = Number(toSlider.value);

      if (fromVal > toVal) {
        [fromVal, toVal] = [toVal, fromVal];
      }

      fromInput.value = fromVal;
      toInput.value = toVal;

      const maxVal = this.unit === 'pyeong' ? 100 : 330;
      const track = this.gui.querySelector('.aptrank-custom-filter-slider-track');
      track.style.left = `${(fromVal / maxVal) * 100}%`;
      track.style.right = `${100 - (toVal / maxVal) * 100}%`;
    });

    this.gui.querySelector('.to-slider').addEventListener('input', () => {
      const fromSlider = this.gui.querySelector('.from-slider');
      const toSlider = this.gui.querySelector('.to-slider');
      const fromInput = this.gui.querySelector('input.title-from');
      const toInput = this.gui.querySelector('input.title-to');

      let fromVal = Number(fromSlider.value);
      let toVal = Number(toSlider.value);

      if (fromVal > toVal) {
        [fromVal, toVal] = [toVal, fromVal];
      }

      fromInput.value = fromVal;
      toInput.value = toVal;

      const maxVal = this.unit === 'pyeong' ? 100 : 330;
      const track = this.gui.querySelector('.aptrank-custom-filter-slider-track');
      track.style.left = `${(fromVal / maxVal) * 100}%`;
      track.style.right = `${100 - (toVal / maxVal) * 100}%`;
    });

    // 입력 필드 변경 시 슬라이더 업데이트만 (적용은 버튼으로)
    this.gui.querySelector('input.title-from').addEventListener('input', () => {
      updateSlidersFromInputs();
    });
    this.gui.querySelector('input.title-to').addEventListener('input', () => {
      updateSlidersFromInputs();
    });

    // 단위 전환 버튼
    const m2Btn = this.gui.querySelector('.unit-m2');
    const pyeongBtn = this.gui.querySelector('.unit-pyeong');
    if (m2Btn) {
      m2Btn.addEventListener('click', () => {
        if (this.unit !== 'm2') {
          setUnit('m2');
        }
      });
    }
    if (pyeongBtn) {
      pyeongBtn.addEventListener('click', () => {
        if (this.unit !== 'pyeong') {
          setUnit('pyeong');
        }
      });
    }

    const closeBtn = this.gui.querySelector('.complex-top-filter-panel-close');
    if (closeBtn && this.onClose) {
      closeBtn.addEventListener('click', this.onClose);
    }

    this.gui.querySelectorAll('[data-range]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const [fromText, toText] = String(btn.getAttribute('data-range') || '').split('-');
        const fromVal = Number(fromText || 0);
        const toVal = Number(toText || 999);

        this.gui.querySelector('input.title-from').value = fromVal;
        this.gui.querySelector('input.title-to').value = toVal;

        const maxVal = this.unit === 'pyeong' ? 100 : 330;
        this.gui.querySelector('.from-slider').value = Math.min(fromVal, maxVal);
        this.gui.querySelector('.to-slider').value = Math.min(toVal, maxVal);

        const track = this.gui.querySelector('.aptrank-custom-filter-slider-track');
        track.style.left = `${(Math.min(fromVal, maxVal) / maxVal) * 100}%`;
        track.style.right = `${100 - (Math.min(toVal, maxVal) / maxVal) * 100}%`;
      });
    });

    // 적용 버튼
    this.gui.querySelector('.aptrank-custom-filter-apply').addEventListener('click', (e) => {
      e.stopPropagation();
      e.preventDefault();
      applyFilter();
    });

    // 초기화 버튼
    this.gui.querySelector('.aptrank-custom-filter-reset').addEventListener('click', (e) => {
      e.stopPropagation();
      e.preventDefault();
      this.gui.querySelector('input.title-from').value = '';
      this.gui.querySelector('input.title-to').value = '';
      const maxVal = this.unit === 'pyeong' ? 100 : 330;
      this.gui.querySelector('.from-slider').value = 0;
      this.gui.querySelector('.to-slider').value = maxVal;
      const track = this.gui.querySelector('.aptrank-custom-filter-slider-track');
      track.style.left = '0%';
      track.style.right = '0%';
      this.model = null;
      this.params.filterChangedCallback();
    });
  }

  getGui() {
    return this.gui;
  }

  isFilterActive() {
    return !!this.model;
  }

  doesFilterPass(p) {
    if (!this.model) return true;
    const raw = String(p?.data?.planTypeName || '');
    const valuesM2 = parseAreaCandidatesM2(raw);
    if (valuesM2.length === 0) return false;
    const unit = this.model.unit === 'pyeong' ? 'pyeong' : 'm2';
    const fromM2 = unit === 'pyeong' ? this.model.from * 3.305785 : this.model.from;
    const toM2 = unit === 'pyeong' ? this.model.to * 3.305785 : this.model.to;
    return valuesM2.some((value) => value >= fromM2 && value <= toM2);
  }

  getModel() {
    return this.model;
  }

  setModel(model) {
    this.model = model || null;
    if (this.model?.unit === 'pyeong' || this.model?.unit === 'm2') this.unit = this.model.unit;
    if (this.gui) this.render();
  }
}

export default AreaRangeFilter;
